import { render, staticRenderFns } from "./WCompanyMenu.vue?vue&type=template&id=b0ecb83a&"
import script from "./WCompanyMenu.vue?vue&type=script&lang=ts&"
export * from "./WCompanyMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports